/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * App 内嵌终端：product_list_app（由同名 WAP 终端全量派生，B 位 *_wap 重写为 product_list_app，C/D 不变；677 个 D 位坑位，12 个 C 位模块）。
 * 数据源：product_list_wap（全量派生）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_LIST_APP_SPM_CODES = {
  collection_banner: {
    code: `${sitePrefix}.product_list_app.collection_banner`,
    expand_banner_description: `${sitePrefix}.product_list_app.collection_banner.expand_banner_description`,
  },
  collection_introduction: {
    code: `${sitePrefix}.product_list_app.collection_introduction`,
    expand_collection_description: `${sitePrefix}.product_list_app.collection_introduction.expand_collection_description`,
  },
  color_filter: {
    code: `${sitePrefix}.product_list_app.color_filter`,
    'color_option_{NN}': `${sitePrefix}.product_list_app.color_filter.color_option_{NN}`,
    toggle_color_filter: `${sitePrefix}.product_list_app.color_filter.toggle_color_filter`,
  },
  gender_filter: {
    code: `${sitePrefix}.product_list_app.gender_filter`,
    'gender_option_{NN}': `${sitePrefix}.product_list_app.gender_filter.gender_option_{NN}`,
    toggle_gender_filter: `${sitePrefix}.product_list_app.gender_filter.toggle_gender_filter`,
  },
  list_toolbar: {
    code: `${sitePrefix}.product_list_app.list_toolbar`,
    clear_all: `${sitePrefix}.product_list_app.list_toolbar.clear_all`,
    filter_apply: `${sitePrefix}.product_list_app.list_toolbar.filter_apply`,
    open_filters: `${sitePrefix}.product_list_app.list_toolbar.open_filters`,
    open_sort: `${sitePrefix}.product_list_app.list_toolbar.open_sort`,
    toggle_product_layout: `${sitePrefix}.product_list_app.list_toolbar.toggle_product_layout`,
  },
  material_filter: {
    code: `${sitePrefix}.product_list_app.material_filter`,
    'material_option_{NN}': `${sitePrefix}.product_list_app.material_filter.material_option_{NN}`,
    toggle_material_filter: `${sitePrefix}.product_list_app.material_filter.toggle_material_filter`,
  },
  prescription_filter: {
    code: `${sitePrefix}.product_list_app.prescription_filter`,
    'prescription_option_{NN}': `${sitePrefix}.product_list_app.prescription_filter.prescription_option_{NN}`,
    toggle_prescription_filter: `${sitePrefix}.product_list_app.prescription_filter.toggle_prescription_filter`,
  },
  price_filter: {
    code: `${sitePrefix}.product_list_app.price_filter`,
    'price_option_{NN}': `${sitePrefix}.product_list_app.price_filter.price_option_{NN}`,
    toggle_price_filter: `${sitePrefix}.product_list_app.price_filter.toggle_price_filter`,
  },
  product_results: {
    code: `${sitePrefix}.product_list_app.product_results`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.product_list_app.product_results.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.product_list_app.product_results.favorite_{NNN}`,
    'product_{NNN}': `${sitePrefix}.product_list_app.product_results.product_{NNN}`,
    'try_on_{NNN}': `${sitePrefix}.product_list_app.product_results.try_on_{NNN}`,
  },
  shape_filter: {
    code: `${sitePrefix}.product_list_app.shape_filter`,
    'shape_option_{NN}': `${sitePrefix}.product_list_app.shape_filter.shape_option_{NN}`,
    toggle_shape_filter: `${sitePrefix}.product_list_app.shape_filter.toggle_shape_filter`,
  },
  size_filter: {
    code: `${sitePrefix}.product_list_app.size_filter`,
    'size_option_{NN}': `${sitePrefix}.product_list_app.size_filter.size_option_{NN}`,
    toggle_size_filter: `${sitePrefix}.product_list_app.size_filter.toggle_size_filter`,
  },
  sort_options: {
    code: `${sitePrefix}.product_list_app.sort_options`,
    'sort_option_{NN}': `${sitePrefix}.product_list_app.sort_options.sort_option_{NN}`,
  },
} as const satisfies SpmPageCodes;
